import React from "react";
import PropTypes from "prop-types";
import { email } from "../../config.json";

const Error = props => {
  const { title, link, subtitle, subtitle1, subtitle2 } = props;
  return (
    <div>
      <div className="lead-genereator_wrapper">
        <div className="error_logo" />
        <h1 className="title">{title}</h1>
        {subtitle1 && <div className="subtitle">{subtitle1}</div>}
        {subtitle2 && <div className="subtitle">{subtitle2}</div>}
        <a href={link} className="subtitle">
          {subtitle}
        </a>
        {email && (
          <div className="subtitle">
            oppure invia una email ad &nbsp;
            <a href={`mailto:${email}`}>{email}</a>
            &nbsp; per essere contattato
          </div>
        )}
      </div>
    </div>
  );
};
Error.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  subtitle1: PropTypes.string,
  subtitle2: PropTypes.string,
  link: PropTypes.string
};

Error.defaultProps = {
  subtitle: "",
  subtitle1: "",
  subtitle2: "",
  link: ""
};
export default Error;
